import { render } from "./course-list.vue?vue&type=template&id=a431ae88"
import script from "./course-list.vue?vue&type=script&lang=js"
export * from "./course-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__